import { isString } from 'lodash-es';

import { objectEntries } from '@iconik-io/core/src/object_entries';

import type { ValidationObject } from '../form_context/form_context';
import messages, {
  resolveValidationMessage,
  type ValidationMessages,
} from '../validations/messages';
import validations, {
  type ValidatableModel,
  type ValidatableValue,
  type ValidationName,
} from '../validations/validations';

const isValidationName = (name: string): name is ValidationName =>
  name in validations;

export const getValidationErrors = (
  model: ValidatableModel,
  value: ValidatableValue,
  fieldValidations: ValidationName | string | ValidationObject | undefined,
  fieldValidationMessages: ValidationMessages = {},
): string[] => {
  const errors: string[] = [];
  if (fieldValidations) {
    let validationsObj: ValidationObject;
    if (isString(fieldValidations)) {
      const [name, param] = fieldValidations.split('.');
      validationsObj = isValidationName(name) ? { [name]: param } : {};
    } else {
      validationsObj = fieldValidations;
    }
    for (const [validationName, param] of objectEntries(validationsObj)) {
      const validate = validations[validationName];
      if (validate && !validate(model, value, param)) {
        const validationMessage =
          fieldValidationMessages[validationName] || messages[validationName];
        const errorMessage = resolveValidationMessage(validationMessage, param);
        errors.push(errorMessage || messages.default);
      }
    }
  }
  return errors;
};
